// Brand asset URLs.
// Updated: customer supplied the final cinematic hero render, the silver smart card,
// the new HSM/MegaVault, and the Digital Platform dashboard.
export const ASSETS = {
  logo:
    "https://customer-assets.emergentagent.com/job_c25ffeb1-42ca-4cd4-8171-26007fe77f82/artifacts/8t9tm8im_Logo%201%20blue.png",
  // Final cinematic hero scene — approved version 3
  heroFinal:
    "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/tb87u80q_Hero%20image%203.png",
  // 2-minute Vaultavo cinematic infrastructure film
  video:
    "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/neqw8gj8_Vaultavo%202%20minute%20video.MOV",
  // Silver biometric smart card (transparent background)
  card:
    "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/8kbh1j8e_Vaultavo%20Biometric%20SmartCard%20-%20Silver.png",
  // HSM / MegaVault hardware (transparent background)
  hsm:
    "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/99b423oo_Vaultavo%20HSM%20Megavault.png",
  // Digital Platform dashboard (iPad render)
  platform:
    "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/kr5w560s_Vaultavo%20Digital%20Platform%20%282%29.png",
  // Aliases (resolved below)
  cardNavy: undefined,
  cardSilver: undefined,
  megaVault: undefined,
  silverTexture:
    "https://images.unsplash.com/photo-1773695801784-01f9ff80865b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGJydXNoZWQlMjBhbHVtaW51bSUyMHRleHR1cmUlMjBzaWx2ZXIlMjBtZXRhbGxpY3xlbnwwfHx8fDE3NzgwNjM5MjJ8MA&ixlib=rb-4.1.0&q=85",
};
ASSETS.cardNavy = ASSETS.card;
ASSETS.cardSilver = ASSETS.card;
ASSETS.megaVault = ASSETS.hsm;
